<template>
  <v-row justify="center">
    <v-dialog v-model="active" max-width="400">      
      <v-card class="pa-3">
        <div class="close-dialog-btn">
          <v-icon color="#D8DDE4" @click="close">mdi-close</v-icon>
        </div>        
        <v-card-title class="text-h5 my-1" style="font-weight:800">
          {{title}}
        </v-card-title>
        <v-card-text class="text-left mt-1" style="font-weight:600; min-height:80px; font-size:15px">
          {{content}}
        </v-card-text>
        <v-card-actions class="px-3" style="justify-content:center">
          <v-btn outlined color="#81C0E2" style="width: 150px; height:46px; border-radius: 10px;" @click="close">
            取消
          </v-btn>
          <v-btn outlined color="#FFF" style="width: 150px; height:46px; border-radius: 10px; background:#81C0E2" @click="save">
            確定
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
  export default {
    name:'ShowConfirm',
    props:['onSave'],
    data () {
      return {
        active: false,
        title: '',
        content: '',
        onSaveEn: false,
      }
    },
    methods:{
      open(type = null, title = null, content = null, onSaveEn = false){
        this.active = true
        this.onSaveEn = onSaveEn
        switch(type){
          case 0:
          default:
            this.title = title
            this.content = content
            break
          case 1:
            this.title = '確定刪除'
            this.content = '您確定要刪除勾選資料嗎 ?'
            break
          case 2:
            this.title = '確定刪除'
            this.content = '您確定要刪除此筆資料嗎 ?'
            break
        }
      },
      close(){
        this.active = false
      },
      save(){
        if(this.onSaveEn){
          this.onSave()
        }
        this.close()
      }
    }
  }
</script>